import { isPlatformServer } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { AssetService } from '../../services/asset.service';

@Injectable({
  providedIn: 'root',
})
export class AllGalleryAssetsResolve {
  private assetService = inject(AssetService);
  private platformId = inject<string>(PLATFORM_ID);

  async resolve(route: ActivatedRouteSnapshot) {
    if (isPlatformServer(this.platformId)) return;
    const gallery = route.parent.data.gallery;
    if (!gallery) return;

    const debugTimeout = setTimeout(() => {
      console.warn('timeout reached');
      console.warn('subjects', this.assetService['subjects']);
      console.warn('subjectMaxPage', this.assetService['subjectMaxPage']);
      console.warn('subjectPages', this.assetService['subjectPages']);
      console.warn('subjectPagesDone', this.assetService['subjectPagesDone']);
      console.warn('oldCache', this.assetService['oldCache']);
    }, 15_1000);

    const resp = await this.assetService.getAssetsForGallery(gallery.id, { sorted: true });
    clearTimeout(debugTimeout);
    return resp;
  }
}
